export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///37A7uXl5QAAACH5BAAAAAAALAAAAAASAAwAAAIkhI95we3fhJpHyNSmXZChzYXfZXhlkIBAZxoqhyov9bF2TE8FADs="